export default "../images/stack.svg?ef6c2823eaaacaa683cf022e42e87eae";